import type { ToastServiceMethods } from 'primevue/toastservice';
import type { FileInfo } from '../types/File';
import { getAPIUrl } from './getApiUrl';

export function formatBytesToMB(bytes: number): string {
  const megabytes = bytes / (1024 * 1024);
  const formattedString = `${megabytes.toFixed(2)} MB`;
  return formattedString;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  }
  else if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
  else {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
}

function downloadZippedFiles(files: FileInfo[], zipname: string = 'files', skipDate: boolean = false, clrPrefix: string = '') {
  if (files.length === 0)
    return;

  const API_URL = getAPIUrl();

  const today = new Date();
  const fileName = skipDate ? zipname : `${zipname}_${today.getDate()}_${today.getMonth() + 1}_${today.getFullYear()}`;
  const ids = files.filter(file => file.status === 'done').map(file => file.id).join(',');

  const url = `${API_URL}files/downloads?file_ids=${ids}&zipname=${fileName}${clrPrefix ? `&color=${clrPrefix}` : ''}`;

  const temporaryDownloadLink = document.createElement('a');
  temporaryDownloadLink.style.display = 'none';
  temporaryDownloadLink.setAttribute('download', `${fileName}.zip`);
  temporaryDownloadLink.setAttribute('href', url);
  temporaryDownloadLink.click();
  temporaryDownloadLink.remove();

  /**
   * LEFT FOR FUTURE AWE
   */
  // const ids = files.filter(file => file.status === 'done').map(file => file.id);
  // const res = await axiosInstance.get(`/files/downloads`, { responseType: 'arraybuffer', params: { file_ids: file_ids.join(',') } });
  // if (!res)
  //   return;

  // const blob = new Blob([res.data], { type: res.headers['content-type'] });
  // const contentDisposition = res.headers['content-disposition'];
  // const filenameMatch = contentDisposition && contentDisposition.match(/filename="(.+)"/);
  // const filename = filenameMatch ? filenameMatch[1] : 'downloaded_file.zip';

  // const temporaryDownloadLink = document.createElement('a');
  // temporaryDownloadLink.style.display = 'none';
  // temporaryDownloadLink.setAttribute('download', filename);
  // temporaryDownloadLink.setAttribute('href', window.URL.createObjectURL(blob));
  // temporaryDownloadLink.click();
  // document.body.removeChild(temporaryDownloadLink);
}

export function validateAndDownloadZip({ files, zipname = 'files', skipDate = false, toast, t, clrPrefix }: { files: FileInfo[], zipname?: string, skipDate?: boolean, toast: ToastServiceMethods, t: (a: string, arg?: any) => string, clrPrefix?: string }) {
  const validFiles: FileInfo[] = [];
  files.forEach((f) => {
    if (f.status === 'done') {
      validFiles.push(f);
    }
  });

  if (validFiles.length === 0) {
    toast.add({ severity: 'error', summary: t('toast.zipError.summary'), detail: t('toast.zipError.detail'), life: 6000 });
    return;
  }
  toast.add({ severity: 'info', summary: t('toast.zipDownload.summary'), detail: t('toast.zipDownload.detail'), life: 5000 });

  // Show additional message AFTER the main one for potential missing files
  if (validFiles.length < files.length) {
    toast.add({ severity: 'warn', summary: t('toast.zipMissing.summary'), detail: t('toast.zipMissing.detail', { num: files.length - validFiles.length }), life: 5000 });
  }

  downloadZippedFiles(validFiles, zipname, skipDate, clrPrefix);
}
